import { Check, Dashboard, Space } from "../../types";
import { Colors, Metrics } from "../../resources";
import React, { useState } from "react";
import { ScrollView, StyleSheet, View } from "react-native";
import { animated, useSpring } from "react-spring";
import { useSettings, useSpaces, useTags } from "../../hooks";

import { AxiosResponse } from "axios";
import SListHeader from "../molecules/SListHeader";
import STableListCard from "../molecules/STableListCard";
import moment from "moment";

interface IProps {
  spaces: Space[];
  reports: any;
  updateCapacity: (
    id: string,
    capacity: number
  ) => Promise<AxiosResponse<any> | undefined>;
  updateSafeCapacity: (
    id: string,
    safeCapacity: number
  ) => Promise<AxiosResponse<any> | undefined>;
  addTag: (id: string, tag: string) => Promise<AxiosResponse<any> | undefined>;
  removeTag: (
    id: string,
    tag: string
  ) => Promise<AxiosResponse<any> | undefined>;
}

const STableView: React.FC<IProps> = ({
  spaces,
  reports,
  updateCapacity,
  updateSafeCapacity,
  addTag,
  removeTag,
}) => {
  const [space, setSpace] = useState<Space | null>(null);
  const [row, setRow] = useState<number>(0);

  const { settings } = useSettings();
  const { checkSpace } = useSpaces();
  const { tags } = useTags();

  const [flip, set] = useState(false);
  const props = useSpring({
    to: { opacity: 1 },
    from: { opacity: 0 },
    reset: true,
    reverse: flip,
    delay: 200,
    // config: config.molasses,
    //onRest: () => set(!flip),
  });

  const date = settings?.date
    ? moment(settings?.date).format("YYYY-MM-DD")
    : "";

  const onPress = (row: number, space: Space) => {
    setRow(row);
    setSpace(space);
  };

  const renderCard = ({ item, index }: { item: Space; index: number }) => {
    const onCheck = (check: Check) => {
      checkSpace(item.id, check === Check.Checked ? true : false);
    };

    return (
      //      <animated.div style={props}>
      <STableListCard
        space={item}
        report={
          reports && reports[item.id] ? reports[item.id]["weekly"][date] : null
        }
        onCheck={onCheck}
        updateCapacity={updateCapacity}
        updateSafeCapacity={updateSafeCapacity}
        onPress={() => onPress(index, item)}
        key={item.id}
        addTag={addTag}
        removeTag={removeTag}
      />
      //      </animated.div>
    );
  };

  return (
    <View style={styles.container}>
      <View style={styles.list}>
        <SListHeader type={Dashboard.Table} />
        {/* <FlatList
          data={spaces}
          renderItem={renderCard}
          keyExtractor={(space) => space.id}
          extraData={settings}
        /> */}
        <ScrollView style={{ flex: 1 }}>
          {spaces.map((space: Space, index: number) => {
            return renderCard({ item: space, index });
          })}
        </ScrollView>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "100%",
    backgroundColor: Colors.grey100,
  },
  list: {
    flex: 1,
    marginTop: 35.5,
    marginHorizontal: Metrics.padding32,
  },
});

export default STableView;
